export const InfoSection = () => {
  return (
    <section className="rounded-2xl bg-card p-8 md:p-12">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6">Sobre nossas ferramentas</h2>
        <div className="space-y-4 text-muted-foreground">
          <p>
            Reunimos as melhores ferramentas digitais para o profissional do mercado
            imobiliário. Nossa seleção inclui calculadoras, sistemas de consulta e
            recursos que facilitam o dia a dia de corretores, cartórios e investidores.
          </p>
          <p>
            Cada ferramenta foi escolhida para agregar valor ao seu trabalho, ajudando
            você a tomar decisões mais rápidas e assertivas no mercado imobiliário.
          </p>
        </div>
      </div>
    </section>
  );
};
